<template>
  <v-flex
    id="warehouseView"
    xs12
  >
    <h2 class="header mb-0">
      {{ $t('warehouses.preview.title') }}
    </h2>
    <v-flex
      md10
      offset-md1
      sm12
      offset-sm0
    >
      <v-layout
        :mt-5="$vuetify.breakpoint.smAndUp"
        mb-0
        fill-height
        wrap
      >
        <v-flex xs12>
          <v-alert
            :value="true"
            class="py-3"
            :class="{ 'mx-3': $vuetify.breakpoint.xsOnly }"
          >
            <p class="ma-0">
              {{ $t('warehouses.preview.alert') }}
            </p>
          </v-alert>
        </v-flex>
        <v-flex xs12>
          <v-layout
            mt-4
            fill-height
            wrap
            :class="{ 'mx-3': $vuetify.breakpoint.xsOnly }"
          >
            <v-flex
              xs12
              lg6
              py-3
            >
              <v-layout
                fill-height
                align-center
                justify-center
                :mr-3="$vuetify.breakpoint.lgAndUp"
                class="sz_background_light"
              >
                <v-flex
                  shrink
                  mx-3
                >
                  <BaseIcon
                    height="64px"
                    width="64px"
                  >
                    <PaczkopediaIcon icon-color="#9DA0A1" />
                  </BaseIcon>
                </v-flex>
                <v-flex
                  shrink
                  mx-3
                  mt-3
                >
                  <p class="f-24 fw-600 mb-0">
                    {{ $t('warehouses.preview.delivery') }}
                  </p>
                  <p class="f-1">
                    {{ $t('warehouses.preview.code') }}:
                    <span class="sz_grey--text">{{ $t('warehouses.preview.tmp_code') }}</span>
                  </p>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex
              xs12
              lg6
              py-3
            >
              <v-layout
                row
                py-3
                fill-height
                align-center
                class="sz_background_light"
                :ml-3="$vuetify.breakpoint.lgAndUp"
              >
                <v-flex
                  xs6
                  px-3
                >
                  <p class="f-1 fw-600 mb-0">
                    {{ $t('warehouses.preview.contact') }}
                  </p>
                  <p class="f-14 sz_dark_grey--text">
                    {{ $t('warehouses.preview.opening_hours') }}
                  </p>
                  <p class="f-14 sz_grey--text mb-0">
                    {{ $t('warehouses.preview.tmp_contact') }}
                  </p>
                  <div v-if="false">
                    <p class="f-14 sz_dark_grey--text mb-0">
                      Piotr Kowalski
                    </p>
                    <p class="f-14 sz_dark_grey--text mb-0">
                      {{ '123456189' | phone }}
                    </p>
                    <p class="f-14 sz_dark_grey--text">
                      asd@gmail.com
                    </p>
                  </div>
                </v-flex>
                <v-divider vertical />
                <v-flex
                  xs6
                  px-3
                >
                  <p class="f-14 sz_dark_grey--text my-3">
                    {{ $t('warehouses.preview.questions') }}
                  </p>
                  <p class="f-14 sz_dark_grey--text fw-600 mb-0">
                    {{ fullName }}
                  </p>
                  <p class="f-14 sz_dark_grey--text">
                    {{ phoneNumber | phone }}
                  </p>
                  <p
                    v-if="false"
                    class="f-14 sz_dark_grey--text fw-600 mb-0"
                  >
                    Antonina Krasystaw
                  </p>
                  <p
                    v-if="false"
                    class="f-14 sz_dark_grey--text"
                  >
                    {{ '123456189' | phone }}
                  </p>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout
            mt-5
            wrap
            :class="{ 'mx-3': $vuetify.breakpoint.xsOnly }"
          >
            <v-flex
              xs12
              sm4
              px-1
            >
              <p class="f-1 fw-600 mb-2">
                {{ $t('warehouses.preview.where') }}
              </p>
              <p class="f-14 sz_dark_grey--text mb-2">
                {{ locationName }}
              </p>
              <p class="f-14 sz_dark_grey--text mb-0">
                {{ fullStreet }}
              </p>
              <p class="f-14 sz_dark_grey--text">
                {{ postalCode | postalCode }} {{ city }}
              </p>
            </v-flex>
            <v-flex
              xs12
              sm4
              px-1
            >
              <p class="f-1 fw-600 mb-2">
                {{ $t('warehouses.preview.when') }}
              </p>
              <p
                v-if="firstDayChecked"
                class="f-14 sz_dark_grey--text mb-0"
              >
                {{ days[0].description }}
                {{ firstDayFrom | timeInput }}-{{ firstDayTo | timeInput }}
              </p>
              <p class="f-14 sz_dark_grey--text mb-0">
                {{ days[1].description }}
                {{ secondDayFrom | timeInput }}-{{ secondDayTo | timeInput }}
              </p>
              <p
                v-if="lastDayChecked"
                class="f-14 sz_dark_grey--text"
              >
                {{ days[2].description }}
                {{ thirdDayFrom | timeInput }}-{{ thirdDayTo | timeInput }}
              </p>
            </v-flex>
            <v-flex
              xs12
              sm4
              px-1
            >
              <p class="f-1 fw-600 mb-2">
                {{ $t('warehouses.preview.directions') }}
              </p>
              <p class="f-14 sz_dark_grey--text mb-2">
                {{ directions }}
              </p>
              <p
                v-if="isTruckAccess"
                class="f-14"
              >
                <v-icon :color="$vuetify.theme.sz_green">
                  check
                </v-icon>
                {{ $t('warehouses.preview.truck_access') }}
              </p>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-divider class="my-4" />
  </v-flex>
</template>

<script>
import BaseIcon from '@/icons/BaseIcon';
import PaczkopediaIcon from '@/icons/PaczkopediaIcon';
import filters from '@/constants/filters';

import { mapFields } from 'vuex-map-fields';

export default {
    name: 'WarehousePreview',
    components: { PaczkopediaIcon, BaseIcon },
    filters: {
        ...filters
    },
    props: {
        warehouseType: {
            type: Number,
            required: true
        }
    },
    computed: {
        ...mapFields('warehouses', ['addWarehouse', 'addSupportingWarehouse']),
        fullName () {
            return this.warehouseType === 1
                ? this.addWarehouse.warehouseManager.full_name
                : this.addSupportingWarehouse.warehouseManager.full_name;
        },
        phoneNumber () {
            return this.warehouseType === 1
                ? this.addWarehouse.warehouseManager.phone
                : this.addSupportingWarehouse.warehouseManager.phone;
        },
        locationName () {
            return this.warehouseType === 1
                ? this.addWarehouse.locationData.address.locationName
                : this.addSupportingWarehouse.locationData.address.locationName;
        },
        postalCode () {
            return this.warehouseType === 1
                ? this.addWarehouse.locationData.address.postalCode
                : this.addSupportingWarehouse.locationData.address.postalCode;
        },
        city () {
            const _data =
        this.warehouseType === 1
            ? this.addWarehouse.locationData.address.city
            : this.addSupportingWarehouse.locationData.address.city;
            return _data === null ? '' : _data;
        },
        firstDayChecked () {
            return this.warehouseType === 1
                ? this.addWarehouse.locationData.openingHours.additionalFirstDayChecked
                : true;
        },
        lastDayChecked () {
            return this.warehouseType === 1
                ? this.addWarehouse.locationData.openingHours.additionalThirdDayChecked
                : this.addSupportingWarehouse.locationData.openingHours.additionalThirdDayChecked;
        },
        firstDayFrom () {
            return this.warehouseType === 1
                ? this.addWarehouse.locationData.openingHours.firstDayFrom
                : this.addSupportingWarehouse.locationData.openingHours.firstDayFrom;
        },
        firstDayTo () {
            return this.warehouseType === 1
                ? this.addWarehouse.locationData.openingHours.firstDayTo
                : this.addSupportingWarehouse.locationData.openingHours.firstDayTo;
        },
        secondDayFrom () {
            return this.warehouseType === 1
                ? this.addWarehouse.locationData.openingHours.secondDayFrom
                : this.addSupportingWarehouse.locationData.openingHours.secondDayFrom;
        },
        secondDayTo () {
            return this.warehouseType === 1
                ? this.addWarehouse.locationData.openingHours.secondDayTo
                : this.addSupportingWarehouse.locationData.openingHours.secondDayTo;
        },
        thirdDayFrom () {
            return this.warehouseType === 1
                ? this.addWarehouse.locationData.openingHours.thirdDayFrom
                : this.addSupportingWarehouse.locationData.openingHours.thirdDayFrom;
        },
        thirdDayTo () {
            return this.warehouseType === 1
                ? this.addWarehouse.locationData.openingHours.thirdDayTo
                : this.addSupportingWarehouse.locationData.openingHours.thirdDayTo;
        },
        directions () {
            return this.warehouseType === 1
                ? this.addWarehouse.locationData.directions
                : this.addSupportingWarehouse.locationData.directions;
        },
        days () {
            return this.$store.getters['warehouses/getResource'].find((el) => {
                return el.id === 1003;
            }).resources;
        },
        fullStreet () {
            let _placeNumber;
            let _street;
            let _flatNumber;
            if (this.warehouseType === 1) {
                _placeNumber =
          this.addWarehouse.locationData.address.flatNumber != null
              ? '/' + this.addWarehouse.locationData.address.flatNumber
              : '';
                _street = this.addWarehouse.locationData.address.street
                    ? this.addWarehouse.locationData.address.street
                    : '';
                _flatNumber =
          this.addWarehouse.locationData.address.placeNumber === null
              ? ''
              : this.addWarehouse.locationData.address.placeNumber;
            } else if (this.warehouseType === 2) {
                _placeNumber =
          this.addSupportingWarehouse.locationData.address.flatNumber != null
              ? '/' + this.addSupportingWarehouse.locationData.address.flatNumber
              : '';
                _street = this.addSupportingWarehouse.locationData.address.street
                    ? this.addSupportingWarehouse.locationData.address.street
                    : '';
                _flatNumber =
          this.addSupportingWarehouse.locationData.address.placeNumber === null
              ? ''
              : this.addSupportingWarehouse.locationData.address.placeNumber;
            }
            return _street + ' ' + _flatNumber + _placeNumber;
        },
        isTruckAccess () {
            return this.warehouseType === 1
                ? this.addWarehouse.additionalParameters.truckAccess === 'yes'
                : this.addSupportingWarehouse.additionalParameters.truckAccess === 'yes';
        }
    }
};
</script>

<style scoped></style>
